import { MedplumClient } from "@medplum/core";
import { DocumentReference } from "@medplum/fhirtypes";

import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { deleteFile as apiDeleteFile } from "@/utils/uploads";

import { RootState } from "..";

const uploadedFilesAdapter = createEntityAdapter({
  selectId: (uploadedFile: DocumentReference) => uploadedFile.id!,
});

export const deleteFileThunk = createAsyncThunk(
  "uploadedFiles/delete",
  async ({ medplum, file }: { medplum: MedplumClient; file: DocumentReference }, { dispatch }) => {
    await apiDeleteFile(medplum, file);
    if (file.id) {
      dispatch(removeUploadedFile(file.id));
    }
  },
);

const reducers = {
  loadUploadedFiles: uploadedFilesAdapter.setAll,
  upsertUploadedFile: uploadedFilesAdapter.upsertOne,
  removeUploadedFile: uploadedFilesAdapter.removeOne,
};

export const uploadedFilesSlice = createSlice({
  name: "uploadedFiles",
  initialState: uploadedFilesAdapter.getInitialState(),
  reducers,
  extraReducers: (builder) => {
    builder.addCase(deleteFileThunk.rejected, (state, action) => {
      console.error("Error deleting file:", action.error);
    });
  },
});

export const { loadUploadedFiles, upsertUploadedFile, removeUploadedFile } =
  uploadedFilesSlice.actions;

export const selectUploadedFiles = (state: RootState) => state.uploadedFiles.entities;

export default uploadedFilesSlice.reducer;
